import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Ban } from "lucide-react";

import "./card/text-elements.css";

import "./helper-elements.css";
export const NoDataSmall = () => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      gap="15px"
      paddingTop="30px"
    >
      <Ban
        data-testid="asoc-acc-no-elements"
        className="responsive-icon"
        color={AppColors.GRAY_ICON}
      />
      <Text
        className="account-value-label"
        fontWeight={600}
        color={AppColors.GRAY_TEXT}
      >
        No hay datos disponibles
      </Text>
    </Flex>
  );
};
